import React from 'react'
import notePad from "../../../images/padu/notepad.webp"
import rocket from "../../../images/padu/rocket.webp"
import logo from "../../../images/students/workfast-logo.webp"
import { LuCircleCheckBig } from 'react-icons/lu'
import vivekananda from "../../../images/padu/vivekananda.webp"
import sk from "../../../images/surge/sk-anna.webp"

export default function Powered() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center bg-[#F9FAFB]'>
            <img src={logo} alt='logo' loading='lazy' className='size-[80px] md:size-[150px] lg:size-[180px] mx-auto' />
            <h3 className='text-[#101828] text-[24px] md:text-[44px] font-semibold mt-[15px] md:mt-[30px]'>Powered by Workfast AI</h3>
            <div className='mt-[18px] md:mt-[32px] grid md:grid-cols-2 gap-[20px] md:gap-[50px] md:w-11/12 mx-auto text-start'>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={notePad} alt='notePad' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Structure & Routine</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Habit streaks.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Daily mindset nudges</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Task templates</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Students need industry direction.</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Skill-based challenges</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={rocket} alt='rocket' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Students Said</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Passion-driven execution</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Weekly growth reports</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>AI guidance</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[63px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Community energy</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-[20px] md:mt-[32px] bg-[#FFDD091A] w-full md:w-9/12 mx-auto rounded-[12px] md:rounded-[20px] p-[15px] md:p-[24px] text-[#897700] text-center font-semibold text-[18px] md:text-[28px]'>
                <p>Students don’t just learn — they perform every day.</p>
            </div>
            <div className='mt-[20px] md:mt-[40px] grid lg:grid-cols-2 gap-[20px] w-11/12 mx-auto text-start'>
                <div className='w-full border border-[#C6C6C8] rounded-[12px] md:rounded-[20px]' style={{ boxShadow: "0px 0px 11px -4px #0000001A" }}>
                    <img src={vivekananda} alt='vivekananda' loading='lazy' className='rounded-t-[12px] md:rounded-t-[20px] w-full object-cover'/>
                    <div className='p-[12px] md:p-[20px] rounded-b-[12px] md:rounded-b-[12px]'>
                        <p className='text-[#007300] font-semibold text-[17px] md:text-[25px]'>Give me 100 energetic young men and I shall transform <br/> India.</p>
                        <p className='mt-[4px] md:mt-[8px] text-[#002400] text-[12px] md:text-[20px] font-medium'>— Swami Vivekananda</p>
                    </div>
                </div>
                <div className='w-full border border-[#C6C6C8] rounded-[12px] md:rounded-[20px]' style={{ boxShadow: "0px 0px 11px -4px #0000001A" }}>
                    <img src={sk} alt='sk' loading='lazy' className='rounded-t-[12px] md:rounded-t-[20px] w-full object-cover'/>
                    <div className='p-[12px] md:p-[20px] rounded-b-[12px] md:rounded-b-[12px]'>
                        <p className='text-[#007300] font-semibold text-[17px] md:text-[25px]'>We will choose 100 energetic students, and together, we will transform India.</p>
                        <p className='mt-[4px] md:mt-[8px] text-[#002400] text-[12px] md:text-[20px] font-medium'>— SK</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
